import { MortgageInterface } from '@app/interfaces/mortgage.interface';
import { DocumentStatusEnum } from '@app/enums/document-status.enum';

export class FillingScore2800 {
    static check(mortgage: MortgageInterface): boolean {
        return !!mortgage._contacts.every((applicant) =>
            applicant._documents && applicant._documents.length
                ? applicant._documents
                      .filter((d) => d._template.groupId === 10 && !d.isArchived)
                      .every((d) => [DocumentStatusEnum.checking, DocumentStatusEnum.done].includes(d.status))
                : false
        );
    }
}
